// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSupportIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M20 2c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4 .01-18c0-1.1.89-2 1.99-2zm-7.793 11.38a1.27 1.27 0 0 0-.933.384 1.27 1.27 0 0 0-.382.932q0 .549.382.933.384.383.933.383t.933-.383a1.27 1.27 0 0 0 .383-.933 1.27 1.27 0 0 0-.383-.932 1.27 1.27 0 0 0-.933-.383M12.431 4q-1.137 0-1.977.49T9.103 5.83a.67.67 0 0 0-.022.673.95.95 0 0 0 .552.485.94.94 0 0 0 .703 0q.355-.136.579-.43.256-.325.627-.523.37-.197.854-.197.608 0 1.019.344.41.345.41.878 0 .406-.271.877-.273.469-.845.972-.448.406-.717.742a3.7 3.7 0 0 0-.437.688q-.095.195-.14.394-.048.2-.099.444a.8.8 0 0 0 .215.692q.27.293.696.293a.98.98 0 0 0 .663-.262q.295-.262.42-.716.087-.34.3-.64.212-.3.663-.744.815-.815 1.177-1.418.364-.603.364-1.364-.001-1.38-.922-2.199Q13.97 4 12.43 4"
    />
  </g>
);
export default SvgSupportIcon;
SvgSupportIcon.displayName = 'SvgSupportIcon';
